module.exports = __webpack_public_path__ + "assets/img/index-partner28.b061dcac.jpg";